import {
  Button,
  SpaceBetween,
} from '@cloudscape-design/components';
import { OrderTypes } from '@parallel-fluidics/shared/constants';
import React, { useState } from 'react';

const FilterMap = Object.freeze({
  [OrderTypes.CUSTOMER]: 'Customer',
  [OrderTypes.INTERNAL]: 'Internal',
});

export default function useOrderFilter() {
  const [orderType, setOrderType] = useState(null);

  function FilterButtons() {
    return (
      <SpaceBetween direction="horizontal" size="xs" data-element="filterButtons">
        <Button
          variant={!orderType ? 'primary' : 'normal'}
          onClick={() => setOrderType(null)}
          data-current={!orderType ? 'true' : 'false'}
        >
          All
        </Button>
        {Object.keys(FilterMap).map((type) => (
          <Button
            key={type}
            variant={orderType === type ? 'primary' : 'normal'}
            onClick={() => setOrderType(type)}
            data-current={orderType === type ? 'true' : 'false'}
          >
            {FilterMap[type]}
          </Button>
        ))}
      </SpaceBetween>
    );
  }

  return {
    orderType,
    FilterButtons,
  };
}
